export enum ShiftEnum {
  //never change order
  EARLY,
  DAY,
  LATE,
  NIGHT,
}
